import { createContext } from 'react';
var DEFAULT_DENSITY = 'medium';
var DensityContext = /*#__PURE__*/createContext(DEFAULT_DENSITY);
var DensityConsumer = DensityContext.Consumer,
    DensityProvider = DensityContext.Provider;
export { DensityConsumer, DensityProvider };
export default DensityContext;